import fetchExpresso from 'utility/fetchExpresso';
import moment from 'moment-timezone';

export async function getEvents(hostId) {
    const response = await fetchExpresso(`/apiv2/events/?host=${hostId}`);

    if (response.status === 200) {
        const data = await response.json();

        const events = [];
        const childEvents = [];

        // Generate list of events (excluding child events)
        for (const event of data) {
            event.childEvents = [];
            event.status = null;

            if (moment(event.end_date).tz(event.time_zone, true) < moment()) {
                event.status = 'concluded';
            }
            if (
                moment(event.end_date).tz(event.time_zone, true) >= moment() &&
                moment(event.start_date).tz(event.time_zone, true) <= moment()
            ) {
                event.status = 'live';
            }
            if (moment(event.start_date).tz(event.time_zone, true) > moment()) {
                event.status = 'upcoming';
            }

            if (event.parent_event_id) {
                childEvents.push(event);
            } else {
                events.push(event);
            }
        }

        // Keep broken historical relationships visible so hosts can repair them.
        const seasons = new Map();
        for (const event of events) {
            if (Number(event.parent_mode) === 1) seasons.set(String(event.event_id), event);
        }
        for (const childEvent of childEvents) {
            const parent = seasons.get(String(childEvent.parent_event_id));
            if (parent) parent.childEvents.push(childEvent);
            else events.push(childEvent);
        }

        return events;
    } else if (response.status === 400) {
        throw new Error(`[400] Bad request`);
    } else if (response.status === 500) {
        throw new Error(`[500] There was a problem on our end`);
    } else {
        throw new Error(`[${response.status}] Something went wrong`);
    }
}
